import { useEffect, useRef, useState } from "react";
import ProfileHeader from "../../components/user/ProfileHeader";
import { useSelector } from "react-redux";
import Controls from "../../components/visualizations/Controls";
import VisualizationGrid from "../../components/visualizations/VisualizationGrid";
import LoadTrigger from "../../components/common/LoadTrigger";
import { getVisualizations } from "../../services/visualizations.service";
import VisualizationCard from "../../components/visualizations/VisualizationCard";

const MyProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const user = useSelector((state) => state.user);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("publishedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [hasMore, setHasMore] = useState(true);
  const [records, setRecords] = useState([]);
  const pageRef = useRef(1);
  const reqIdRef = useRef(1);
  const syncIsLoadingRef = useRef(false);
  const sortOptions = {
    title: "title",
    PublishedAt: "publishedAt",
    views: "views",
    likes: "likesCount",
  };

  const onLoadMore = async (reset = true) => {
    if (!reset && (syncIsLoadingRef.current || !hasMore)) return;

    setIsLoading(true);
    syncIsLoadingRef.current = true;
    try {
      const query = {
        page: reset ? 1 : pageRef.current,
        sortBy,
        sortOrder,
        ...(search ? { search } : {}),
        createdBy: user.userId,
      };

      if (reset) {
        pageRef.current = 2;
        ++reqIdRef.current;
        setHasMore(true);
      } else {
        pageRef.current++;
      }
      const reqId = reqIdRef.current;

      const visualizationsData = await getVisualizations(query);
      if (reqId !== reqIdRef.current) {
        return;
      }
      setHasMore(visualizationsData.page < visualizationsData.totalPages);
      setRecords((prev) =>
        reset
          ? visualizationsData.records
          : [...prev, ...visualizationsData.records],
      );
    } catch (error) {
      --pageRef.current;
    } finally {
      setIsLoading(false);
      syncIsLoadingRef.current = false;
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(async () => await onLoadMore(true), 500);
    return () => clearTimeout(timeoutId);
  }, [search, sortBy, sortOrder]);

  return (
    <>
      <ProfileHeader user={user} isLoading={isLoading} error={error} />

      <Controls
        setDebouncedSearch={setSearch}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        sortOptions={sortOptions}
      />
      <VisualizationGrid
        records={records}
        isLoading={isLoading}
        Card={VisualizationCard}
      />
      <LoadTrigger
        hasMore={hasMore}
        isLoading={isLoading}
        onLoadMore={onLoadMore}
      />
    </>
  );
};

export default MyProfile;
